// extracted by mini-css-extract-plugin
module.exports = {"newsletter-inline":"newsletter-inline_newsletter-inline__MBGgW","error":"newsletter-inline_error__j9H57"};